import continentsData from "../../data/continents.json";

/**
 * Zone de chaque pays (`af`, `eu`, `as`, `am`), intégrée au bundle : le Défi du
 * jour et les parties par continent en ont besoin dès le premier tirage, sans
 * attendre le chargement de `continents.json` (que Map Nerd charge à part).
 */
export const ZONES = ["af", "eu", "as", "am"];

export const CONTINENTS = Object.fromEntries(
	Object.entries(continentsData)
		.filter(([code]) => !code.startsWith("_"))
		.map(([code, zone]) => [code, String(zone).toLowerCase()])
);

export function zoneOf(code) {
	return CONTINENTS[code] ?? null;
}
